import React from 'react';

const UploadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" fill="none">
      <path
        stroke="#475467"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M16 11.5v1c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C14.1 16.5 13.4 16.5 12 16.5H5c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092C1 14.6 1 13.9 1 12.5v-1m11.667-5.833L8.5 1.5m0 0L4.333 5.667M8.5 1.5v10"
      />
    </svg>
  );
};

export default UploadIcon;

export const NewUploadIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="40" height="40" rx="20" fill="#F2F4F7" />
      <rect
        x="3"
        y="3"
        width="40"
        height="40"
        rx="20"
        stroke="#F9FAFB"
        strokeWidth="6"
      />
      <path
        d="M19.6667 26.3333L23.0001 23M23.0001 23L26.3334 26.3333M23.0001 23V30.5M29.6667 26.9524C30.6847 26.1117 31.3334 24.8399 31.3334 23.4167C31.3334 20.8854 29.2814 18.8333 26.7501 18.8333C26.568 18.8333 26.3976 18.7383 26.3052 18.5814C25.2185 16.7374 23.2121 15.5 20.9167 15.5C17.465 15.5 14.6667 18.2982 14.6667 21.75C14.6667 23.4718 15.363 25.0309 16.4892 26.1613"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
